import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import Spinner from '@/components/Spinner.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateFolderModal',
  props: {
    isLoading: { type: Boolean },
    closeModal: null,
    onCreateFolder: null
  },
  setup(__props: any) {

const props = __props as {
  isLoading: boolean;
  closeModal: () => void;
  onCreateFolder: (folderName: string) => void;
};



const isVisible = ref(true);
const folderName = ref('');

function closeModal(): void {
  if (!isVisible.value || props.isLoading) return;

  folderName.value = '';
  isVisible.value = false;
  props.closeModal();
}

function handleCreate(): void {
  if (!folderName.value || props.isLoading) return;

  props.onCreateFolder(folderName.value);
}

return { __sfc: true,props, isVisible, folderName, closeModal, handleCreate, Spinner }
}

})